import React, { useState } from "react";

export const AreaMapContext = React.createContext({});

const AreaMapProvider = ({ children }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAreaData, setSelectedAreaData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingAreaData, setEditingAreaData] = useState(null);

  return <AreaMapContext.Provider value={{
    modalVisible,
    setModalVisible,
    selectedAreaData,
    setSelectedAreaData,
    isEditMode,
    setIsEditMode,
    editingAreaData,
    setEditingAreaData
  }}>{children}</AreaMapContext.Provider>;
};

export default AreaMapProvider;
